export var WorkflowName;
(function (WorkflowName) {
    WorkflowName["Correctness"] = "Correctness";
    WorkflowName["Quality"] = "Quality";
    WorkflowName["Performance"] = "Performance";
    WorkflowName["Validation"] = "Validation";
    WorkflowName["Deployment"] = "Deployment";
    WorkflowName["Broadcast"] = "Broadcast";
})(WorkflowName || (WorkflowName = {}));
